{
  "SEARCH": {
    "TABS": {
      "ALL": "All results",
      "CONTACTS": "Danh bạ",
      "CONVERSATIONS": "Các cuộc hội thoại",
      "MESSAGES": "Tin nhắn",
      "ARTICLES": "Articles"
    },
    "SECTION": {
      "CONTACTS": "Danh bạ",
      "CONVERSATIONS": "Các cuộc hội thoại",
      "MESSAGES": "Tin nhắn",
      "ARTICLES": "Articles"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Đang tìm kiếm",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/to focus",
    "INPUT_PLACEHOLDER": "Type 3 or more characters to search",
    "RECENT_SEARCHES": "Recent searches",
    "CLEAR_ALL": "Clear all",
    "MOST_RECENT": "Most recent",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Read more",
    "READ_LESS": "Read less",
    "WROTE": "wrote:",
    "FROM": "Từ",
    "EMAIL": "Email",
    "EMAIL_SUBJECT": "Chủ đề",
    "PRIVATE": "Private note",
    "TRANSCRIPT": "Transcript",
    "CREATED_AT": "created {time}",
    "UPDATED_AT": "updated {time}",
    "SORT_BY": {
      "RELEVANCE": "Relevance"
    },
    "DATE_RANGE": {
      "LAST_7_DAYS": "7 ngày cuối",
      "LAST_30_DAYS": "30 ngày cuối",
      "LAST_60_DAYS": "60 ngày cuối",
      "LAST_90_DAYS": "90 ngày cuối",
      "CUSTOM_RANGE": "Custom range:",
      "CREATED_BETWEEN": "Created between",
      "AND": "and",
      "APPLY": "Áp dụng",
      "BEFORE_DATE": "Before {date}",
      "AFTER_DATE": "After {date}",
      "TIME_RANGE": "Filter by time",
      "CLEAR_FILTER": "Clear filter"
    },
    "FILTERS": {
      "FILTER_MESSAGE": "Filter messages by:",
      "FROM": "Người gửi",
      "IN": "Hộp thư đến",
      "AGENTS": "Nhà cung cấp",
      "CONTACTS": "Liên hệ",
      "INBOXES": "Hộp thư đến",
      "NO_AGENTS": "Không tìm thấy nhà cung cấp",
      "NO_CONTACTS": "Start by searching to see results",
      "NO_INBOXES": "No inboxes found"
    }
  }
}
